<template src="./Cobranca.html"></template>

<script>
import store from "@/store";
import { mapMutations } from "vuex";
import devedores from "@/services/devedores";
import dividas from "@/services/dividas";
import ocorrencias from "@/services/ocorrencias";
import enderecodeve from "@/services/enderecodeve";
import usuario from "@/services/usuario";
import Endereco from '@/pages/cobranca/Endereco';
import Telefone from '@/pages/cobranca/Telefone';
import Email from '@/pages/cobranca/Email';
import Negociacao from '@/pages/cobranca/Negociacao';
import Acordos from '@/pages/cobranca/Acordos';
import moment from "moment";
import StringMask from "string-mask";


async function asyncForEach(array, callback) {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array);
  }
}
export default {
  components: {
    Endereco,
    Telefone,
    Email,
    Negociacao,
    Acordos
  },
  name: 'Cobranca',
  data () {
    return {
      model: {},
      message: "",
      search: "",
      tipoConsulta: 1,
      dialogDevedores: false,
      dialogOcorrencia: false,

      date2: new Date().toISOString().substr(0, 10),
      dateFormatted2: this.formatDate(new Date().toISOString().substr(0, 10)),
      menu2: false,
      modal2: false,

      user: {},
      devedores: [],
      active: 0,
      items: ['Negociando', 'Promessa de Acordo', 'Recado Formal', 'Recado com terceiro', 
              'Sem condições', 'Deslocalizado', 'Recusa', 
              'Falecido', 'Tentativa de Contato', 'Black List'],
      
      mask: '(##) #####-####',
      maskCPF: '###.###.###-##',
      maskCNPJ: '##.###.###/####-##',
      maskHora: '##:##',
      valid: true,
      headersOcorrencias: [{
          text: 'Data',
          align: 'left',
          sortable: true,
          value: 'createdAt'
        },
        {
          text: 'Telefone',
          align: 'left',
          sortable: true,
          value: 'telefone'
        },
        {
          text: 'Ação',
          align: 'left',
          sortable: true,
          value: 'status'
        },
        {
          text: 'Sub Ação',
          align: 'left',
          sortable: true,
          value: 'subacao',
          width: '40%'
        },
        {
          text: 'Retorno',
          align: 'left',
          sortable: true,
          value: 'data'
        },
        {
          text: 'Hora',
          align: 'left',
          sortable: true,
          value: 'hora'
        },
        {
          text: 'Operador',
          align: 'left',
          sortable: true,
          value: 'user.name'
        }
      ],
      headersDividas: [{
          text: 'Contrato',
          align: 'left',
          sortable: true,
          value: 'Identificador'
        },
        {
          text: 'Empresa',
          align: 'left',
          sortable: true,
          value: 'idcliente.Nome',
          width: '40%'
        },
        {
          text: 'Valor Divida',
          align: 'left',
          sortable: true,
          value: 'ValorEmpresa'
        },
        {
          text: 'Status',
          align: 'left',
          sortable: true,
          value: 'StatusDivida'
        },
        {
          text: 'Ações',
          value: 'action'
        }
      ],
      
      headersPdfs: [{
          text: 'Nome  Anexo',
          align: 'left',
          sortable: true,
          value: 'descricao',
        }
      ],
      headers: [{
          text: 'Nome',
          align: 'left',
          sortable: true,
          value: 'Nome'
        },{
          text: 'CPF ou CNPJ',
          align: 'left',
          sortable: true,
          value: 'CnpjCpf'
        },
        {
          text: 'Endereco',
          align: 'left',
          sortable: true,
          value: 'Endereco'
        }
      ],
      
      subRules: [
        v => !!v || 'Sub Ação deve ser informado.',
        v => (v && v.length >= 10) || 'Nome deve ser maior que 10 caracteres.'
      ],
      telefoneRules: [
        v => !!v || 'Telefone deve ser informado!',
        v => (v && /^\([1-9]{2}\) [0-9]{5}\-[0-9]{4}$/.test(v)) || 'Telefone inválido.'
      ],
    }
  },
  computed: {
    computedDateFormatted2 () {
      return this.formatDate(this.date2)
    },
    devedor() {
      return this.$store.getters["devedor"];
    },
    acordo() {
      return this.$store.getters["acordo"];
    },
    loading() {
      return this.$store.getters["loading"];
    },
  },
  
  watch: {
    date2 (val) {
      this.dateFormatted2 = this.formatDate(this.date2)
      this.model.data = this.date2;
    },
  },
  async created () {
    this.setLoading(true);
    this.tipoConsulta = 1;
    this.user = await usuario.getUsuario(this.$store.getters.user._id);
    this.setDevedor({});
    if (this.$route.params.id || this.$route.query.cpf) {
      let deve = await devedores.getDevedoreId(this.$route.params.id);
      if (!deve) {
        let cpf = "";
        if (this.$route.query && this.$route.query.cpf) {
          cpf = this.$route.query.cpf.replace('.', '').replace('.', '').replace('.', '').replace('-', '').replace('/', '');
        } else {
          cpf = this.$route.params.id;
        }
        if (cpf.length < 11) {
          cpf = cpf.padStart(11, '0');
        } else if (cpf.length > 11 && cpf.length < 14) {
          cpf = cpf.padStart(14, '0');
        }
        if (cpf.length == 11) {
          let formatterCPF = new StringMask(this.maskCPF);
          let result = formatterCPF.apply(cpf);
          let retorno = await devedores.getSearch(result);
          if (retorno.length > 0) {
            deve = await devedores.getDevedoreId(retorno[0]._id);
          }
        } else if (cpf.length == 14) {
          let formatterCNPJ = new StringMask(this.maskCNPJ);
          let result = formatterCNPJ.apply(cpf);
          let retorno = await devedores.getSearch(result);
          if (retorno.length > 0) {
            deve = await devedores.getDevedoreId(retorno[0]._id);
          }
        }
      }
      
      this.setDevedor(deve);
      if (this.devedor.dividas && this.devedor.dividas.length > 0) {
        this.setAcordo(this.devedor.dividas[0].acordo);
      } else {
        this.setAcordo({});
      }
    }
    this.active = 0;
    this.$forceUpdate();
    this.setLoading(false);
  },
  methods: {
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    async proximo () {
      this.setLoading(true);
      this.setDevedor({});
      this.active = 0;
      this.setDevedor(await devedores.getDevedoreId(-1));
      if (this.devedor.dividas && this.devedor.dividas.length > 0) {
        this.setAcordo(this.devedor.dividas[0].acordo);
      } else {
        this.setAcordo({});
      }
      this.setLoading(false);
      this.dialogDevedores=false;
    },
    
    async getSearch (search) {
      
      if (search) {
        this.setLoading(true);
        search = encodeURIComponent(search);
        this.devedores = await devedores.getSearch(search);
        if (this.devedores && this.devedores.length > 1) {
          this.dialogDevedores = true;
        } else if (this.devedores.length == 0) {
          this.setDevedor({});
        } else {
          
          this.setDevedor({});
          this.active = 0;
          this.setDevedor(await devedores.getDevedoreId(this.devedores[0]._id));
          if (this.devedor.dividas && this.devedor.dividas.length > 0) {
            this.setAcordo(this.devedor.dividas[0].acordo);
          } else {
            this.setAcordo({});
          }
          
          //this.setDevedor(this.devedores[0]);
        } 
        this.setLoading(false);
      }
    },
    getStatusAcordo (divida) {
      if (divida && divida.ValorRepasse === 0) {
        return 'Quitado';
      }
      if (divida.StatusDivida == 1) {
        return 'Processo Cobrança';
      } else if (divida.StatusDivida == 2) {
        return 'Aguardando Aprovação';
      } else if (divida.StatusDivida == 3) {
        return 'Acordo Vigente';
      } else if (divida.StatusDivida == 4) {
        return 'Acordo em Atraso';
      } else if (divida.StatusDivida == 5) {
        return 'Divida Bloqueada';
      } else if (divida.StatusDivida == 6) {
        return 'Deslocalizado';
      } else if (divida.StatusDivida == 8) {
        return 'Bloqueado';
      }
    },
    getColor (status) {
      if (status == "Falecido" || status == 'Black List') {
        return 'black white--text'
      } else if (status == "Pagamento de Parcela") {
        return 'pink lighten-4 black--text'
      } else {
        return 'green lighten-2 black--text'
      } 
    },
    getColorDivida (divida) {
      if (divida && divida.ValorRepasse === 0) {
        return 'pink lighten-4 black--text';
      }
    },
    async novaOcorrencia (devedor) {
      this.model = {devedor: devedor._id};
      this.model.data = this.date2;
      this.dialogOcorrencia = true;
    },
    async bloquearDevedor (devedor) {
      if (this.user.acesso == 'Admin' || this.user.acesso == 'Advogado') {
        this.setLoading(true);
        devedor.IsAtivo = !devedor.IsAtivo;
        let dev = await devedores.save(devedor);
        this.setDevedor(await devedores.getDevedoreId(devedor._id));
        if (this.devedor.dividas && this.devedor.dividas.length > 0) {
          this.setAcordo(this.devedor.dividas[0].acordo);
        } else {
          this.setAcordo({});
        }
        this.active = 0;
        this.setLoading(false);
      }
    },
    async bloquearDivida (divida) {
      if (this.user.acesso == 'Admin' || this.user.acesso == 'Advogado') {
        this.setLoading(true);
        divida.IsBloqueado = !divida.IsBloqueado;
        let dev = await dividas.saveStatus(divida);
        this.setDevedor(await devedores.getDevedoreId(this.devedor._id));
        if (this.devedor.dividas && this.devedor.dividas.length > 0) {
          this.setAcordo(this.devedor.dividas[0].acordo);
        } else {
          this.setAcordo({});
        }
        this.active = 0;
        this.setLoading(false);
      }
    },
    async salvar () {
      if (this.$refs.form.validate()) {
        this.setLoading(true);
        if (this.model.agendamento && !this.model.data) {
          this.setError("Data deve ser informada")
          this.setLoading(false);
          return;
        }
        if (this.model.agendamento && !this.model.hora) {
          this.setError("Hora deve ser informada")
          this.setLoading(false);
          return;
        }
        this.model.user = this.user._id;
        await ocorrencias.save(this.model);
        this.dialogOcorrencia = false;
        this.setDevedor(await devedores.getDevedoreId(this.model.devedor));
        if (this.devedor.dividas && this.devedor.dividas.length > 0) {
          this.setAcordo(this.devedor.dividas[0].acordo);
        } else {
          this.setAcordo({});
        }
        this.setLoading(false);
        this.$forceUpdate();
      }
    },
    async selectedDevedor (item) {
      this.setLoading(true);
      this.setDevedor({});
      this.active = 0;
      this.setDevedor(await devedores.getDevedoreId(item._id));
      if (this.devedor.dividas && this.devedor.dividas.length > 0) {
        this.setAcordo(this.devedor.dividas[0].acordo);
      } else {
        this.setAcordo({});
      }
      this.setLoading(false);
      this.dialogDevedores=false;
    },
    setAcordoInterno (item) {
      this.setAcordo(item.acordo);
    },
    ...mapMutations({
      setError: "setError",
      setLoading: "setLoading",
      setDevedor: "setDevedor",
      setAcordo: "setAcordo",
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="css" scoped>
  html {
    font-family: Arial !important;
  }
  v-input {
    font-family: Arial !important;
  }
  h3 {
    font-family: Arial !important;
  }
  h4 {
    font-family: Arial !important;
  }
  h5 {
    font-family: Arial !important;
  }
  h6 {
    font-family: Arial !important;
    font-size: 8px;
  }
  .welcome {
    font-size: 24px !important;
    font-weight: 500;
    margin-bottom: 50px;
    margin-right: 20px;
  }

  .content-into-desconto {
    background-color: rgb(206, 206, 206);
    width: 100%;
    min-height: 650px;
    border-radius: 200px; 
  }
  .diarioobra {
    font-size: 36px !important;
    font-family: 'Montserrat-Black', sans-serif !important;
    font-weight: 900;
    font-style: normal;
    padding-top: 10px;
    margin-bottom: 10px !important;
    color: #231f20;
  }
</style>




// WEBPACK FOOTER //
// src/pages/cobranca/Cobranca.vue